// Mock data para la demo del sistema de tasación
export const publicaciones = [
  {
    id: 1,
    marca: 'Chevrolet',
    modelo: 'Onix',
    version: 'Premier',
    año: 2020,
    motor: '1.0 Turbo',
    kilometraje: 45000,
    combustible: 'Nafta',
    transmision: 'Automática',
    puertas: 5,
    estado: 'Excelente',
    unicoDueño: true,
    descripcion: 'Vehículo en excelente estado, único dueño, service completo en concesionario oficial.',
    expectativaCliente: 13000,
    valoracionVendedor: 12800,
    patente: 'ABC1234',
    fecha: '2025-01-15',
    // Datos de tasación
    autodata: { toma: 12500, venta: 15800 },
    mercadoLibre: { promedio: 13200, menor: 11500, mayor: 15900, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 12300, ale2: 12700 },
    revendedores: [
      { nombre: 'El Tano', oferta: 13500 },
      { nombre: 'Los Pinos', oferta: 13200 },
      { nombre: 'AutoMax', oferta: 12900 },
      { nombre: 'Super Autos', oferta: 12700 },
      { nombre: 'La Boutique', oferta: 12500 },
      { nombre: 'El Corral', oferta: 12300 },
      { nombre: 'AutoVip', oferta: 12200 },
      { nombre: 'Express Cars', oferta: 12000 },
      { nombre: 'Premium Motors', oferta: 11900 },
      { nombre: 'Sur Autos', oferta: 11800 },
      { nombre: 'Norte Motors', oferta: 11700 },
      { nombre: 'Centro Autos', oferta: 11500 },
    ],
    fotos: [
      'https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=800',
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800',
    ]
  },
  {
    id: 2,
    marca: 'Volkswagen',
    modelo: 'Gol',
    version: 'Trend',
    año: 2019,
    motor: '1.6',
    kilometraje: 62000,
    combustible: 'Nafta',
    transmision: 'Manual',
    puertas: 5,
    estado: 'Bueno',
    unicoDueño: false,
    descripcion: 'Vehículo bien cuidado, sin detalles importantes. Listo para transferir.',
    expectativaCliente: 9500,
    valoracionVendedor: 9200,
    patente: 'DEF5678',
    fecha: '2025-01-14',
    autodata: { toma: 8800, venta: 11200 },
    mercadoLibre: { promedio: 9300, menor: 8200, mayor: 10500, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 8900, ale2: 9100 },
    revendedores: [
      { nombre: 'AutoMax', oferta: 9600 },
      { nombre: 'El Tano', oferta: 9400 },
      { nombre: 'Los Pinos', oferta: 9200 },
      { nombre: 'La Boutique', oferta: 9000 },
      { nombre: 'Super Autos', oferta: 8800 },
      { nombre: 'El Corral', oferta: 8700 },
      { nombre: 'Premium Motors', oferta: 8500 },
    ],
    fotos: []
  },
  {
    id: 3,
    marca: 'Fiat',
    modelo: 'Cronos',
    version: 'Drive',
    año: 2021,
    motor: '1.3',
    kilometraje: 28000,
    combustible: 'Nafta',
    transmision: 'Manual',
    puertas: 4,
    estado: 'Excelente',
    unicoDueño: true,
    descripcion: 'Vehículo prácticamente nuevo, pocos kilómetros, único dueño. Impecable.',
    expectativaCliente: 12500,
    valoracionVendedor: 12000,
    patente: 'GHI9012',
    fecha: '2025-01-13',
    autodata: { toma: 11800, venta: 14500 },
    mercadoLibre: null, // Esperando datos
    gerencia: { alex1: 11900, ale2: 12100 },
    revendedores: [
      { nombre: 'Los Pinos', oferta: 12400 },
      { nombre: 'El Tano', oferta: 12200 },
      { nombre: 'AutoVip', oferta: 12000 },
    ],
    fotos: []
  },
  {
    id: 4,
    marca: 'Jeep',
    modelo: 'Renegade',
    version: 'Sport',
    año: 2018,
    motor: '1.8',
    kilometraje: 78000,
    combustible: 'Nafta',
    transmision: 'Automática',
    puertas: 5,
    estado: 'Bueno',
    unicoDueño: false,
    descripcion: 'SUV en buen estado general, service al día, ideal para familia.',
    expectativaCliente: 16500,
    valoracionVendedor: 16000,
    patente: 'JKL3456',
    fecha: '2025-01-12',
    autodata: { toma: 15200, venta: 18900 },
    mercadoLibre: { promedio: 16800, menor: 14500, mayor: 19200, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 15800, ale2: 16200 },
    revendedores: [
      { nombre: 'Premium Motors', oferta: 16800 },
      { nombre: 'AutoMax', oferta: 16500 },
      { nombre: 'El Tano', oferta: 16200 },
      { nombre: 'Sur Autos', oferta: 16000 },
      { nombre: 'Los Pinos', oferta: 15800 },
    ],
    fotos: []
  },
  {
    id: 5,
    marca: 'Renault',
    modelo: 'Sandero',
    version: 'Zen',
    año: 2020,
    motor: '1.6',
    kilometraje: 52000,
    combustible: 'Nafta',
    transmision: 'Manual',
    puertas: 5,
    estado: 'Bueno',
    unicoDueño: true,
    descripcion: 'Vehículo funcional, muy económico, ideal primer auto.',
    expectativaCliente: 10200,
    valoracionVendedor: 9800,
    patente: 'MNO7890',
    fecha: '2025-01-11',
    autodata: { toma: 9400, venta: 12100 },
    mercadoLibre: { promedio: 10100, menor: 8900, mayor: 11500, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: null, // Esperando datos
    revendedores: [
      { nombre: 'El Corral', oferta: 10300 },
      { nombre: 'AutoMax', oferta: 10000 },
      { nombre: 'Express Cars', oferta: 9800 },
      { nombre: 'Centro Autos', oferta: 9500 },
    ],
    fotos: []
  },
  {
    id: 6,
    marca: 'Toyota',
    modelo: 'Corolla',
    version: 'XEi',
    año: 2017,
    motor: '2.0',
    kilometraje: 95000,
    combustible: 'Nafta',
    transmision: 'Automática',
    puertas: 4,
    estado: 'Bueno',
    unicoDueño: false,
    descripcion: 'Sedán confiable, mecánica impecable, ideal para uso diario.',
    expectativaCliente: 14800,
    valoracionVendedor: 14200,
    patente: 'PQR1234',
    fecha: '2025-01-10',
    autodata: { toma: 13500, venta: 16800 },
    mercadoLibre: { promedio: 14500, menor: 12800, mayor: 16200, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 13800, ale2: 14000 },
    revendedores: [
      { nombre: 'Premium Motors', oferta: 14900 },
      { nombre: 'AutoVip', oferta: 14600 },
      { nombre: 'Los Pinos', oferta: 14400 },
      { nombre: 'El Tano', oferta: 14200 },
      { nombre: 'AutoMax', oferta: 14000 },
      { nombre: 'La Boutique', oferta: 13800 },
    ],
    fotos: []
  },
  {
    id: 7,
    marca: 'Peugeot',
    modelo: '208',
    version: 'Active',
    año: 2019,
    motor: '1.5',
    kilometraje: 41000,
    combustible: 'Nafta',
    transmision: 'Manual',
    puertas: 5,
    estado: 'Excelente',
    unicoDueño: true,
    descripcion: 'Hatchback moderno, muy cuidado, bajo consumo.',
    expectativaCliente: 11000,
    valoracionVendedor: 10600,
    patente: 'STU5678',
    fecha: '2025-01-09',
    autodata: { toma: 10200, venta: 13200 },
    mercadoLibre: null, // Esperando datos
    gerencia: { alex1: 10400, ale2: 10600 },
    revendedores: [
      { nombre: 'El Tano', oferta: 11100 },
      { nombre: 'Los Pinos', oferta: 10900 },
      { nombre: 'AutoMax', oferta: 10700 },
    ],
    fotos: []
  },
  {
    id: 8,
    marca: 'Nissan',
    modelo: 'Kicks',
    version: 'Sense',
    año: 2020,
    motor: '1.6',
    kilometraje: 35000,
    combustible: 'Nafta',
    transmision: 'Automática',
    puertas: 5,
    estado: 'Excelente',
    unicoDueño: true,
    descripcion: 'SUV compacta, muy linda, pocos kilómetros. Estado impecable.',
    expectativaCliente: 17500,
    valoracionVendedor: 17000,
    patente: 'VWX9012',
    fecha: '2025-01-08',
    autodata: { toma: 16200, venta: 19800 },
    mercadoLibre: { promedio: 17200, menor: 15800, mayor: 19500, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 16500, ale2: 16800 },
    revendedores: [
      { nombre: 'Premium Motors', oferta: 17600 },
      { nombre: 'AutoVip', oferta: 17400 },
      { nombre: 'Los Pinos', oferta: 17200 },
      { nombre: 'El Tano', oferta: 17000 },
      { nombre: 'AutoMax', oferta: 16800 },
      { nombre: 'La Boutique', oferta: 16500 },
      { nombre: 'Sur Autos', oferta: 16300 },
      { nombre: 'Express Cars', oferta: 16000 },
    ],
    fotos: []
  },
  {
    id: 9,
    marca: 'Ford',
    modelo: 'Ranger',
    version: 'XLT',
    año: 2016,
    motor: '3.2 Diesel',
    kilometraje: 145000,
    combustible: 'Diesel',
    transmision: 'Manual',
    puertas: 4,
    estado: 'Regular',
    unicoDueño: false,
    descripcion: 'Pickup de trabajo, mecánica en buen estado, necesita algunos detalles de chapa.',
    expectativaCliente: 18500,
    valoracionVendedor: 17800,
    patente: 'YZA3456',
    fecha: '2025-01-07',
    autodata: { toma: 17000, venta: 21500 },
    mercadoLibre: { promedio: 18200, menor: 16500, mayor: 20800, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 17500, ale2: 18000 },
    revendedores: [
      { nombre: 'El Corral', oferta: 18800 },
      { nombre: 'Premium Motors', oferta: 18500 },
      { nombre: 'AutoMax', oferta: 18200 },
      { nombre: 'Sur Autos', oferta: 18000 },
      { nombre: 'Norte Motors', oferta: 17800 },
    ],
    fotos: []
  },
  {
    id: 10,
    marca: 'Honda',
    modelo: 'Fit',
    version: 'LX',
    año: 2018,
    motor: '1.5',
    kilometraje: 68000,
    combustible: 'Nafta',
    transmision: 'Automática',
    puertas: 5,
    estado: 'Bueno',
    unicoDueño: true,
    descripcion: 'Hatchback espacioso, muy confiable, excelente para ciudad.',
    expectativaCliente: 11800,
    valoracionVendedor: 11400,
    patente: 'BCD7890',
    fecha: '2025-01-06',
    autodata: { toma: 10800, venta: 13800 },
    mercadoLibre: null, // Esperando datos
    gerencia: null, // Esperando datos
    revendedores: [
      { nombre: 'AutoVip', oferta: 11900 },
      { nombre: 'El Tano', oferta: 11700 },
    ],
    fotos: []
  },
  {
    id: 11,
    marca: 'Mitsubishi',
    modelo: 'L200',
    version: 'Triton',
    año: 2015,
    motor: '2.4 Diesel',
    kilometraje: 168000,
    combustible: 'Diesel',
    transmision: 'Manual',
    puertas: 4,
    estado: 'Regular',
    unicoDueño: false,
    descripcion: 'Pickup robusta, mucho uso pero mecánica sana. Ideal trabajo.',
    expectativaCliente: 15500,
    valoracionVendedor: 14800,
    patente: 'EFG1234',
    fecha: '2025-01-05',
    autodata: { toma: 14200, venta: 17800 },
    mercadoLibre: { promedio: 15100, menor: 13500, mayor: 17200, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 14500, ale2: 15000 },
    revendedores: [
      { nombre: 'El Corral', oferta: 15700 },
      { nombre: 'Sur Autos', oferta: 15400 },
      { nombre: 'AutoMax', oferta: 15200 },
      { nombre: 'Norte Motors', oferta: 15000 },
    ],
    fotos: []
  },
  {
    id: 12,
    marca: 'Hyundai',
    modelo: 'Tucson',
    version: 'GLS',
    año: 2019,
    motor: '2.0',
    kilometraje: 55000,
    combustible: 'Nafta',
    transmision: 'Automática',
    puertas: 5,
    estado: 'Excelente',
    unicoDueño: true,
    descripcion: 'SUV muy completa, full equipo, único dueño, estado impecable.',
    expectativaCliente: 19500,
    valoracionVendedor: 19000,
    patente: 'HIJ5678',
    fecha: '2025-01-04',
    autodata: { toma: 18200, venta: 22500 },
    mercadoLibre: { promedio: 19300, menor: 17500, mayor: 21800, urlMenor: 'https://mercadolibre.com.uy', urlMayor: 'https://mercadolibre.com.uy' },
    gerencia: { alex1: 18500, ale2: 19000 },
    revendedores: [
      { nombre: 'Premium Motors', oferta: 19800 },
      { nombre: 'AutoVip', oferta: 19500 },
      { nombre: 'Los Pinos', oferta: 19200 },
      { nombre: 'El Tano', oferta: 19000 },
      { nombre: 'La Boutique', oferta: 18800 },
      { nombre: 'AutoMax', oferta: 18500 },
      { nombre: 'Sur Autos', oferta: 18300 },
    ],
    fotos: []
  },
];
